import React from "react";
import { Phone, ArrowRight } from "lucide-react";
import { COMPANY, IMAGES } from "../../mock";
import { useEstimate } from "../EstimateContext";

export default function CTASection() {
  const { openEstimate } = useEstimate();
  return (
    <section className="relative py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMAGES.basement1} alt="Renovated space" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0f2740]/90" />
      </div>
      <div className="container-x relative z-10 text-center reveal">
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight max-w-3xl mx-auto mb-6">
          Ready for the first step on your renovation project?
        </h2>
        <p className="text-white/75 text-lg max-w-2xl mx-auto mb-10">
          Tell us what you're envisioning for your space and we'll reach out to learn more and build a plan that fits your goals and budget.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <button onClick={openEstimate} className="group px-8 py-4 rounded-full bg-[#2f9fe6] text-white font-semibold flex items-center gap-2 hover:bg-[#1f82c7] transition-all hover:shadow-xl hover:shadow-[#2f9fe6]/30">
            Get an Estimate
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </button>
          <a href={COMPANY.phoneHref} className="px-8 py-4 rounded-full border border-white/30 text-white font-semibold flex items-center gap-2 hover:bg-white/10 transition-colors">
            <Phone className="w-5 h-5" /> {COMPANY.phone}
          </a>
        </div>
      </div>
    </section>
  );
}
